export const API_HOST = process.env.VUE_APP_API_URL || '/';
export const PATH_SEARCH = `${API_HOST}`;
